import React, { lazy, Suspense } from 'react';

import Navbar from '../../components/common/Header/Navbar';
import bannerimg from '../../assets/About-page-assets/about_us_banner.png';
import aboutusimg from '../../assets/About-page-assets/banner-img.png';
import background1 from '../../assets/About-page-assets/backgroud1.png';
import missionvissonimg from '../../assets/About-page-assets/mission_vission.png';
import target from '../../assets/About-page-assets/target.png';
import arrow from '../../assets/About-page-assets/arrow.png';
// import globe from '../../assets/About-page-assets/globe.gif'; // Add your globe image here
const CoreValues = lazy(() => import('../../components/ui/About_core_values'));
const HowItWorks = lazy(() => import('../../components/ui/HowItWorks'));

const About = () => {
  // Core values data
  const values = [
    { name: "Customer First", description: "We focus on delivering value-driven solutions tailored to our clients' needs.", icon: arrow },
    { name: "Efficiency", description: "Our APIs are designed for seamless integration and high-speed performance.", icon: arrow },
    { name: "Scalability", description: "Our APIs support business growth, ensuring seamless expansion and adaptability.", icon: arrow },
    { name: "Innovation", description: "We continuously develop cutting-edge API solutions to meet evolving market needs.", icon: arrow },
    { name: "Security", description: "We prioritize data protection with advanced encryption and fraud prevention measures.", icon: arrow },
    { name: "Adaptability", description: "Placeholder for a sixth segment.", icon: arrow },
  ];

  return (
    <>
      {/* Navbar */}
      {/* <Navbar /> */}

      {/* Banner Section (Already Responsive) */}

      <div className="relative w-full h-[300px] md:h-auto min-h-52">
        <img
          src={bannerimg}
          alt="About Banner"
          className="w-full h-full object-cover" style={{ marginTop: "41px" }}
        />
        <div className="absolute inset-0  flex flex-col items-center justify-center px-6 py-12"> {/* Added vertical padding */}
          <h1
            className="text-white text-4xl md:text-6xl lg:text-[80px] font-normal font-goldman text-center leading-tight md:leading-normal" // Made font size responsive
          >
            About Us
          </h1>

          <p
            className="text-[#D9D9D9] text-base md:text-xl lg:text-[22px] text-center max-w-2xl font-dmsans font-normal leading-normal tracking-[0.22px] mt-2" // Made font size responsive and added margin top
          >
            Empowering Businesses with Secure and Scalable API Solutions.
          </p>
        </div>
      </div>

      {/* Content Section (RESPONSIVE IMPROVEMENTS) */}
      <div
        className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 py-16"
        style={{
          backgroundImage: `url(${background1})`,
          backgroundSize: "cover",
          // backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="max-w-7xl mx-auto w-full flex flex-col md:flex-row items-center  rounded-lg overflow-hidden gap-8 p-6 md:p-12">

          {/* Left Side: Image */}
          <div className="w-full md:w-1/2 flex justify-center">
            <img
              src={aboutusimg}
              alt="About Us Illustration"
              className="object-cover rounded-lg w-[90%] sm:w-[80%] sm:h-[30%] lg:w-[500px] lg:h-[500px] md:w-[500px] md:h-[385px]"
              // style={{ width: "517px", height: "506px" }}
            />
          </div>

          {/* Right Side: Content */}
          <div className="w-full md:w-1/2 text-center md:text-left pt-4 md:pt-0">
            <h5
              className="text-[#2F56A6] uppercase font-semibold text-[22px] tracking-[0.22px] mb-[10px] font-dmsans"
            >
              About API Galaxy
            </h5>

            <h3 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4 leading-tight font-dmsans">
              Secure & Scalable API <br className="hidden md:block" /> Solutions
            </h3>

            <p
              className="text-base  lg:text-lg md:text-sm text-gray-500 leading-relaxed font-dmsans text-justify"

            >
              We are committed to revolutionizing the way NBFCs and fintech startups integrate and manage digital transactions.
              Our cutting-edge API solutions ensure high performance, security, and scalability, making digital payments, identity verification, and other essential services seamless for businesses of all sizes.
              With expertise in Verification, Recharge, Travel, Hotel, and BBPS, we empower businesses to operate efficiently and securely.
              Our APIs are designed for easy integration and reliability, helping organizations streamline their operations.
              At API Galaxy, we create a frictionless ecosystem where businesses can focus on innovation and growth without worrying about technical complexities.
            </p>
          </div>
        </div>
      </div>


      {/* Our Mission Section (RESPONSIVE IMPROVEMENTS) */}


      <div className="px-4 py-16 w-full rounded-lg" style={{ backgroundColor: '#F2F6FF' }}>
        <div className="max-w-[1200px] mx-auto">

          {/* Section Header */}
          <header className="mb-4 text-left">
            <h5 className="text-[#2F56A6] font-dmsans text-lg md:text-[22px] font-semibold uppercase tracking-[0.22px] leading-normal mb-4">
              OUR MISSION AND VISION
            </h5>
          </header>

          {/* Main Content: HEADING, MISSION/VISION, and ILLUSTRATION */}
          {/* Use a Grid on large screens to align the H1 and Image on the same row (row 1) */}
          <div className="grid lg:grid-cols-2 lg:gap-8 xl:gap-20">

            {/* LEFT COLUMN: H1 and Mission/Vision Text */}
            <div className="lg:col-span-1">

              {/* H1 - Forces two lines and uses mb-10 for spacing before text blocks */}
              <h1 className="text-4xl sm: font-bold text-[#2D2D2D] leading-tight mb-10">
                <span className="inline-flex items-center">
                  Driving Digital Growth with
                  {/* Inline target icon right after "Growth" */}
                  <img
                    src={target}
                    alt="target icon"
                    className="w-8 h-8 sm:w-10 sm:h-10 inline-block ml-2"
                  />
                </span>
                {/* Force line break for the two-line appearance */}
                <br className="lg:block" />
                Secure API Solutions
              </h1>

              {/* Mission & Vision Text Blocks Container (Relative for the divider) */}
              <div className="flex relative flex-col sm:flex-row justify-between gap-8 md:gap-12 w-full pb-10 lg:pb-0">

                {/* Mission Box */}
                <div className="w-full sm:w-1/2 flex flex-col">
                  <div className="flex items-center mb-4">
                    <img
                      src={arrow}
                      alt="arrow icon"
                      className="flex-shrink-0 w-[30px] h-[30px] mr-3"
                    />
                    <span className="text-[#2F56A6] font-dmsans text-xl font-semibold leading-[136.5%]">
                      Mission
                    </span>
                  </div>
                  <p className="text-base leading-relaxed text-[#787B82] font-dmsans">
                    To provide high-performance, secure, and scalable API solutions that help businesses optimize digital transactions and enhance customer experiences.
                  </p>
                </div>

                {/* Vertical Dashed Divider - Only visible on large screens */}
                {/* Positioned relative to its parent container */}
                <div
                  className="hidden lg:block absolute left-1/2 top-0 bottom-0 transform -translate-x-1/2 w-0.5"
                  style={{
                    borderLeft: '2px dashed #d8e3f4', // Custom dashed line style
                    height: '100%',
                  }}
                ></div>

                {/* Horizontal Divider - visible on mobile, hidden on tablet+ */}
                <div className="sm:hidden border-t-2 border-dashed border-[#d8e3f4] w-full my-4"></div>

                {/* Vision Box */}
                <div className="w-full sm:w-1/2 flex flex-col">
                  <div className="flex items-center mb-4">
                    <img
                      src={arrow}
                      alt="arrow icon"
                      className="flex-shrink-0 w-[30px] h-[30px] mr-3"
                    />
                    <span className="text-[#2F56A6] font-dmsans text-xl font-semibold leading-[136.5%]">
                      Vision
                    </span>
                  </div>
                  <p className="text-base leading-relaxed text-[#787B82] font-dmsans">
                    To become a global leader in API technology, enabling businesses to innovate, grow, and seamlessly integrate digital solutions into their operations.
                  </p>
                </div>

              </div>
            </div>

            {/* RIGHT COLUMN: Illustration/Image Container */}
            {/* This element is now on the first row of the grid, aligning with the H1 */}
            <div className="lg:col-span-1 flex justify-center items-start w-full lg:mt-0">
              <img
                src={missionvissonimg}
                alt="Mission and Vision Illustration"
                className="w-full h-auto object-contain rounded-lg lg:max-w-[482px] md:max-w-[382px]"
              />
            </div>
          </div>
        </div>
      </div>


      {/* Core Values Section (Assuming CoreValues is responsive) */}
      <Suspense fallback={<div className="text-center py-10 text-gray-500">Loading...</div>}>
        <CoreValues values={values} />
        <HowItWorks values={values} />
      </Suspense>


    </>
  );
};

export default About;